const constants = [
  {
    'key_string'     : 'CATEGORY',
    'value_name'     : 'カテゴリー(中央競馬登録抹消_３歳)',
    'sort_order'     : 1,
    'start_datetime' : '2022-03-07 19:22:49',
    'end_datetime'   : '9999-12-31 00:00:00',
    'value1'         : '1',
    'value2'         : '中央競馬登録抹消_３歳',
    'value3'         : '',
    'value4'         : '',
    'value5'         : '',
    'file_url'       : null,
    'language_code'  : 'ja'
  },
  {
    'key_string'     : 'CATEGORY',
    'value_name'     : 'カテゴリー(中央競馬登録抹消_３歳以上)',
    'sort_order'     : 2,
    'start_datetime' : '2022-03-07 19:22:00',
    'end_datetime'   : '9999-12-31 00:00:00',
    'value1'         : '2',
    'value2'         : '中央競馬登録抹消_３歳以上',
    'value3'         : '',
    'value4'         : '',
    'value5'         : '',
    'file_url'       : null,
    'language_code'  : 'ja'
  },
  {
    'key_string'     : 'CATEGORY',
    'value_name'     : 'カテゴリー(地方競馬在籍)',
    'sort_order'     : 3,
    'start_datetime' : '2022-03-07 19:22:49',
    'end_datetime'   : '9999-12-31 00:00:00',
    'value1'         : '3',
    'value2'         : '地方競馬在籍',
    'value3'         : '',
    'value4'         : '',
    'value5'         : '',
    'file_url'       : null,
    'language_code'  : 'ja'
  },
  {
    'key_string'     : 'CATEGORY',
    'value_name'     : 'カテゴリー(繁殖牝馬)',
    'sort_order'     : 4,
    'start_datetime' : '2022-03-07 19:22:49',
    'end_datetime'   : '9999-12-31 00:00:00',
    'value1'         : '4',
    'value2'         : '繁殖牝馬',
    'value3'         : '',
    'value4'         : '',
    'value5'         : '',
    'file_url'       : null,
    'language_code'  : 'ja'
  },
  {
    'key_string'     : 'GENDER',
    'value_name'     : '性別(牡)',
    'sort_order'     : 1,
    'start_datetime' : '2022-03-07 19:22:49',
    'end_datetime'   : '9999-12-31 00:00:00',
    'value1'         : '1',
    'value2'         : '牡馬',
    'value3'         : '',
    'value4'         : '',
    'value5'         : '',
    'file_url'       : null,
    'language_code'  : 'ja'
  },
  {
    'key_string'     : 'GENDER',
    'value_name'     : '性別(牝)',
    'sort_order'     : 2,
    'start_datetime' : '2022-03-07 19:22:00',
    'end_datetime'   : '9999-12-31 00:00:00',
    'value1'         : '2',
    'value2'         : '牝馬',
    'value3'         : '',
    'value4'         : '',
    'value5'         : '',
    'file_url'       : null,
    'language_code'  : 'ja'
  },
  {
    'key_string'     : 'GENDER',
    'value_name'     : '性別(セン)',
    'sort_order'     : 3,
    'start_datetime' : '2022-03-07 19:22:00',
    'end_datetime'   : '9999-12-31 00:00:00',
    'value1'         : '3',
    'value2'         : 'セン馬',
    'value3'         : '',
    'value4'         : '',
    'value5'         : '',
    'file_url'       : null,
    'language_code'  : 'ja'
  },
  {
    'key_string'     : 'HAIR_COLOR',
    'value_name'     : '毛色(栗毛)',
    'sort_order'     : 1,
    'start_datetime' : '2022-03-07 19:22:49',
    'end_datetime'   : '9999-12-31 00:00:00',
    'value1'         : '1',
    'value2'         : '栗毛',
    'value3'         : '',
    'value4'         : '',
    'value5'         : '',
    'file_url'       : null,
    'language_code'  : 'ja'
  },
  {
    'key_string'     : 'HAIR_COLOR',
    'value_name'     : '毛色(栃栗毛)',
    'sort_order'     : 2,
    'start_datetime' : '2022-03-07 19:22:49',
    'end_datetime'   : '9999-12-31 00:00:00',
    'value1'         : '2',
    'value2'         : '栃栗毛',
    'value3'         : '',
    'value4'         : '',
    'value5'         : '',
    'file_url'       : null,
    'language_code'  : 'ja'
  },
  {
    'key_string'     : 'HAIR_COLOR',
    'value_name'     : '毛色(鹿毛)',
    'sort_order'     : 3,
    'start_datetime' : '2022-03-07 19:22:49',
    'end_datetime'   : '9999-12-31 00:00:00',
    'value1'         : '3',
    'value2'         : '鹿毛',
    'value3'         : '',
    'value4'         : '',
    'value5'         : '',
    'file_url'       : null,
    'language_code'  : 'ja'
  },
  {
    'key_string'     : 'HAIR_COLOR',
    'value_name'     : '毛色(黒鹿毛)',
    'sort_order'     : 4,
    'start_datetime' : '2022-03-07 19:22:49',
    'end_datetime'   : '9999-12-31 00:00:00',
    'value1'         : '4',
    'value2'         : '黒鹿毛',
    'value3'         : '',
    'value4'         : '',
    'value5'         : '',
    'file_url'       : null,
    'language_code'  : 'ja'
  },
  {
    'key_string'     : 'HAIR_COLOR',
    'value_name'     : '毛色(青鹿毛)',
    'sort_order'     : 5,
    'start_datetime' : '2022-03-07 19:22:49',
    'end_datetime'   : '9999-12-31 00:00:00',
    'value1'         : '5',
    'value2'         : '青鹿毛',
    'value3'         : '',
    'value4'         : '',
    'value5'         : '',
    'file_url'       : null,
    'language_code'  : 'ja'
  },
  {
    'key_string'     : 'HAIR_COLOR',
    'value_name'     : '毛色(青毛)',
    'sort_order'     : 6,
    'start_datetime' : '2022-03-07 19:22:49',
    'end_datetime'   : '9999-12-31 00:00:00',
    'value1'         : '6',
    'value2'         : '青毛',
    'value3'         : '',
    'value4'         : '',
    'value5'         : '',
    'file_url'       : null,
    'language_code'  : 'ja'
  },
  {
    'key_string'     : 'HAIR_COLOR',
    'value_name'     : '毛色(芦毛)',
    'sort_order'     : 7,
    'start_datetime' : '2022-03-07 19:22:49',
    'end_datetime'   : '9999-12-31 00:00:00',
    'value1'         : '7',
    'value2'         : '芦毛',
    'value3'         : '',
    'value4'         : '',
    'value5'         : '',
    'file_url'       : null,
    'language_code'  : 'ja'
  },
  {
    'key_string'     : 'HAIR_COLOR',
    'value_name'     : '毛色(白毛)',
    'sort_order'     : 8,
    'start_datetime' : '2022-03-07 19:22:49',
    'end_datetime'   : '9999-12-31 00:00:00',
    'value1'         : '8',
    'value2'         : '白毛',
    'value3'         : '',
    'value4'         : '',
    'value5'         : '',
    'file_url'       : null,
    'language_code'  : 'ja'
  },

]

const detail_auction = {
  'exhibition_item_no' : 1095,
  'lot_id'             : 'YE001',
  'lowest_bid_price'   : 1400000,
  'manage_no'          : 'ITF0025',
  'free_field'         : {
    category             : 1,
    nickname             : 'ベアクイーン',
    birthday             : '2016/05/21',
    age                  : '6歳',
    gender               : '牡',
    color                : '鹿毛',
    status               : 1,
    newsPrice            : 985000,
    father               : 'ホッコータルマエ',
    mother               : 'プラリネ',
    maternal_grandfather : 'アドマイヤムーン',
    total_achievements   : '5戦0勝［0-0-0-5］',
    central_prize_money  : '0.0万円',
    local_prize_money    : '0.0万円',
    weight               : '520kg',
    memo                 : 'Test memo 1242',
    owner                : '(株)エクモ',
    ranching             : 'ノーザンファーム'
  },
  'image' : [
    {
      'file_path'        : 'https://auction.keiba.rakuten.co.jp/data/item/1/0421_horse_25/1.JPG',
      'postar_file_path' : null
    },
    {
      'file_path'        : 'https://auction.keiba.rakuten.co.jp/data/item/1/0421_horse_25/5.JPG',
      'postar_file_path' : null
    },
    {
      'file_path'        : 'https://auction.keiba.rakuten.co.jp/data/item/1/0421_horse_25/6.JPG',
      'postar_file_path' : null
    },
  ]
}

const detail_tender = {
  'exhibition_item_no' : 1095,
  'lot_id'             : 'YE002',
  'lowest_bid_price'   : 1200000,
  'manage_no'          : 'ITF0026',
  'free_field'         : {
    category             : 1,
    nickname             : 'ベアクイーン',
    birthday             : '2016/05/21',
    age                  : '6歳',
    gender               : '牡',
    color                : '鹿毛',
    status               : 1,
    newsPrice            : 985000,
    father               : 'ホッコータルマエ',
    mother               : 'プラリネ',
    maternal_grandfather : 'アドマイヤムーン',
    total_achievements   : '5戦0勝［0-0-0-5］',
    central_prize_money  : '0.0万円',
    local_prize_money    : '0.0万円',
    weight               : '520kg',
    memo                 : 'Test memo 1242',
    owner                : '(株)エクモ',
    ranching             : 'ノーザンファーム'
  },
  'image' : [
    {
      'file_path'        : 'https://auction.keiba.rakuten.co.jp/data/item/1/0421_horse_25/1.JPG',
      'postar_file_path' : null
    },
    {
      'file_path'        : 'https://auction.keiba.rakuten.co.jp/data/item/1/0421_horse_25/5.JPG',
      'postar_file_path' : null
    },
    {
      'file_path'        : 'https://auction.keiba.rakuten.co.jp/data/item/1/0421_horse_25/6.JPG',
      'postar_file_path' : null
    },
  ]
}

const detail_stock = {
  'exhibition_item_no' : 1048,
  'free_field'         : {
    category             : 1,
    nickname             : 'ベアクイーン',
    birthday             : '2016/05/21',
    age                  : '6歳',
    gender               : '牡',
    color                : '鹿毛',
    status               : 1,
    newsPrice            : 985000,
    father               : 'ホッコータルマエ',
    mother               : 'プラリネ',
    maternal_grandfather : 'アドマイヤムーン',
    total_achievements   : '5戦0勝［0-0-0-5］',
    central_prize_money  : '0.0万円',
    local_prize_money    : '0.0万円',
    weight               : '520kg',
    memo                 : 'Test memo 1242',
    owner                : '(株)エクモ',
    ranching             : 'ノーザンファーム'
  },
  'image' : [
    {
      'file_path'        : 'https://auction.keiba.rakuten.co.jp/data/item/1/0421_horse_25/1.JPG',
      'postar_file_path' : null
    },
    {
      'file_path'        : 'https://auction.keiba.rakuten.co.jp/data/item/1/0421_horse_25/5.JPG',
      'postar_file_path' : null
    },
    {
      'file_path'        : 'https://auction.keiba.rakuten.co.jp/data/item/1/0421_horse_25/6.JPG',
      'postar_file_path' : null
    },
  ]
}

export default {
  constants,
  detail_auction,
  detail_tender,
  detail_stock
}
